// extracted by mini-css-extract-plugin
export default {"statistics-container":"AcademyStatistics_statistics-container__uUU-u","statistics-card":"AcademyStatistics_statistics-card__v1CAJ"};